var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInnovationSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.05521 13.3217H1.17207C0.524777 13.3217 0 13.8464 0 14.4937C0 15.141 0.524777 15.6658 1.17207 15.6658H3.05521C4.60774 15.6086 4.60829 13.3791 3.05521 13.3217Z",
    fill: "#1668E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.835 13.3217H36.9519C36.3046 13.3217 35.7798 13.8464 35.7798 14.4937C35.7798 15.141 36.3046 15.6658 36.9519 15.6658H38.835C40.3876 15.6086 40.3881 13.3791 38.835 13.3217Z",
    fill: "#1668E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.19081 3.33817C8.32898 4.39554 9.90612 2.81949 8.84836 1.68062L7.51696 0.349223C7.05931 -0.108433 6.31715 -0.108433 5.85941 0.349223C5.40168 0.80688 5.40168 1.54904 5.85941 2.00677L7.19081 3.33817Z",
    fill: "#1668E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.8172 25.6493C31.679 24.592 30.102 26.1681 31.1596 27.3068L32.491 28.6382C32.9486 29.0958 33.6907 29.0961 34.1486 28.6382C34.6063 28.1806 34.6063 27.4384 34.1486 26.9807L32.8172 25.6493Z",
    fill: "#1668E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.19081 25.6494L5.85941 26.9808C5.40168 27.4384 5.40168 28.1806 5.85941 28.6383C6.31699 29.0959 7.05907 29.0962 7.51696 28.6383L8.84836 27.3069C9.90581 26.1687 8.32952 24.5918 7.19081 25.6494Z",
    fill: "#1668E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.4906 0.349035L31.1592 1.68043C30.7015 2.13809 30.7015 2.88025 31.1592 3.33798C31.6168 3.79556 32.3589 3.79587 32.8168 3.33798L34.1482 2.00658C35.2056 0.868342 33.6294 -0.708489 32.4906 0.349035Z",
    fill: "#1668E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.5112 15.6658L23.3007 17.8762C24.533 20.2599 22.6995 23.2344 20.0038 23.1984C17.973 23.1984 16.3209 21.5463 16.3209 19.5155C16.2851 16.82 19.2595 14.9861 21.6431 16.2187L24.1969 13.6648C24.4166 13.445 24.7148 13.3215 25.0256 13.3215H33.0496C31.2332 -2.47688 8.76866 -2.46531 6.95801 13.3215H14.4966L16.7071 11.111C15.4748 8.72742 17.3083 5.7528 20.004 5.78882C22.0347 5.78882 23.6869 7.441 23.6869 9.47178C23.7227 12.1672 20.7483 14.0011 18.3647 12.7685L15.8109 15.3223C15.5912 15.5421 15.293 15.6657 14.9822 15.6657H6.95887C7.25431 18.94 8.7778 21.9944 11.2426 24.1833C12.5848 25.4241 13.4556 27.0913 13.7225 28.8811C13.7254 28.8807 26.2809 28.8807 26.2853 28.8811C26.5521 27.0917 27.4229 25.4242 28.7653 24.1833C31.2301 21.9944 32.7536 18.94 33.049 15.6657H25.5112V15.6658Z",
    fill: "#1668E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.8101 32.5641C13.8101 35.5786 15.9752 38.0957 18.8319 38.6452C18.7154 40.4613 21.293 40.4602 21.1761 38.6452C24.0327 38.0957 26.1979 35.5786 26.1979 32.5641V31.2252H13.8101V32.5641Z",
    fill: "#1668E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M21.3427 9.47188C21.3427 8.73371 20.7421 8.13306 20.0039 8.13306C18.2302 8.20041 18.2307 10.7436 20.0039 10.8107C20.7421 10.8106 21.3427 10.2101 21.3427 9.47188Z",
    fill: "#1668E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.665 19.5154C18.665 20.2536 19.2657 20.8542 20.0039 20.8542C21.7775 20.7868 21.7771 18.2437 20.0039 18.1766C19.2657 18.1766 18.665 18.7772 18.665 19.5154Z",
    fill: "#1668E8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovationSvg);
export default __webpack_public_path__ + "static/media/InnovationSvg.e56caf4e990b270890ef9d7f000272ee.svg";
export { ForwardRef as ReactComponent };